export type Experiment = {
  key?: string;
  cohort?: string;
  tdfsExp?: string;
  data?: { [key: string]: any };
  dbKey?: string;
};

export enum FeedType {
  AFD = 0,
  RSOC = 1,
  YAHOO = 2,
  MESO = 3,
  ROLLER_ADS = 4,
}

export type LanderConfig = {
  account: string;
  customerId: string;
  portfolioId: string;
  dataSource: string;
  displayType: string;
  rotatorId: string;
  system: string;
  domain?: {
    rootDomain: string;
    rootDomainDisplayText: string;
    rootDomainFromBrowser: string;
    expiresAt: string;
    expired: boolean;
    encryptedDomain: string;
    status: {
      internal: string;
    };
    isAdult: boolean;
    hasAuction: boolean;
    spins: string[];
  };
  adSense?: {
    channel: string;
    drid: string;
    pubId: string;
    keywords?: string[];
  };
  experiment?: Experiment;
  lander?: {
    template: string;
    domainDisplayName: string;
    headerText: string;
    headerHtml: string;
    footerText: string;
    footerHtml: string;
    eventCallbackUrl: string;
    i18n: boolean;
    searchCount?: number;
    feedID?: FeedType;
    banner?: {
      show: boolean;
      type: string;
      link: string;
      text: string;
    };
    // flags
    showDomain: boolean;
  };
  rsoc?: {
    path?: string;
    url?: string;
  };
  yahoo?: {
    typeTag?: string;
  };
  rollerAds?: {
    keywords?: string[];
  };
  turnKeyReseller?: {
    displayName: string;
    programId: string;
    privateLabelId: string;
    privacyUrl: string;
    redirectUrl: string;
  };
};
